import React, { Fragment } from 'react'
import styled from 'styled-components'

export const mailtoString = (songName, artist, shareUrl) => {
  return `mailto:?body=#soundtrackbusiness you just heard ${encodeURIComponent(songName)} by ${encodeURIComponent(artist)}. Listen to the song on Spotify: ${shareUrl}`
}

const ShareLink = styled.a`
  ${({ icon }) => icon && `width: 24px; height: 24px;`}
  transition: color .25s ease-in-out;
  ${({ disabled }) => disabled && `
    color: #ccc;
    cursor: not-allowed;
    pointer-events: none;
  `}
`

export default (props) => {
  return (
    <Fragment>
      <ShareLink disabled={props.disabled} style={props.style} icon={props.icon} href={mailtoString(props.song.name, props.song.artists[0].name, props.song.shareUrl)}>
        {props.icon ? props.icon : 'share'}
      </ShareLink>
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/Components/ShareSong.js